import React from 'react';
import { Box } from '@mui/material';
import termsPdf from '../../assets/terms/Terms and Conditions (E)-  MoiPay Official v2.pdf';

/**
 * Terms & Conditions screen — full-viewport PDF viewer (no chrome wrapper).
 */
const TermsScreen = () => {
  return (
    <Box
      component="iframe"
      src={`${termsPdf}#toolbar=0&navpanes=0&scrollbar=1&view=FitH`}
      title="MoiPay Terms and Conditions"
      sx={{
        width: '100%',
        height: 'calc(100vh - 100px)',
        border: 'none',
        display: 'block',
        margin: 0,
        padding: 0,
        bgcolor: 'transparent',
      }}
    />
  );
};

export default TermsScreen;
